import { initGTM } from './loadGTM';

// Load external scripts dynamically
export const loadRecaptcha = () => {
  const recaptchaSiteKey = import.meta.env?.VITE_RECAPTCHA_SITE_KEY;
  
  if (recaptchaSiteKey && !window.grecaptcha) {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${recaptchaSiteKey}`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
    
    script.onload = () => {
      console.log('reCAPTCHA loaded successfully');
    };
    
    script.onerror = () => {
      console.error('Failed to load reCAPTCHA');
    };
  }
};

// Load all external scripts
export const initExternalScripts = () => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      loadRecaptcha();
      initGTM(); // טען GTM במקום
    });
  } else {
    loadRecaptcha();
    initGTM(); // טען GTM במקום
  }
};
